
import { Swiper, Autoplay, Thumbs } from "swiper";
import "swiper/swiper-bundle.min.css";
export default {
  props: ["imgUrls"],
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      windowWidth: 0,
      swiper: {},
      swiper2: {},
      isOneUpdate: false,

      mediaUrl: this.$config.BASE_URL_RESOURCE,
    };
  },
  mounted() {
    if (!this.isOneUpdate) {
      this.windowWidth = window.innerWidth;
      Swiper.use([Autoplay, Thumbs]);

      this.swiper = new Swiper(".mySwiper", {
        spaceBetween: 10,
        slidesPerView: this.windowWidth > 768 ? 5 : 3,
        freeMode: true,
        lazy: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        watchSlidesProgress: true,
        direction: this.windowWidth > 768 ? "vertical" : "horizontal",
        loop: true,
      });

      this.swiper2 = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 3000,
        },
        thumbs: {
          swiper: this.swiper,
        },
      });

      this.isOneUpdate = true;
    }
  },

  methods: {
    handleClickToSlide() {
      this.swiper.slideNext();
      this.swiper2.slideNext();
      this.swiper.autoplay.start();
      this.swiper2.autoplay.start();
    },
  },
};
